webpackJsonp([8],{

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45424dd8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'offer',
  props: {
    rangeStart: String,
    rangeEnd: String
  },
  data: function data() {
    return {
      href: {
        coworkGroup: 'mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork'
      },
      plans: [{ name: 'Week pass', time: '9 am ~ 6 pm ⌚️', description: ['Available desk in space', '👌 for try out 👀', 'Enjoy insider experience 🙏'],
        price: '50', period: 'week', url: '/day-week-pass-coworking-bratislava',
        cta: 'mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork Week Pass' }, { name: 'Flex Desk', time: '9 am ~ 6 pm ⌚️', description: ['Available desk in space', '👌 for longer stay 🏡', 'You are supporting community 💞'],
        price: '150', period: 'month',
        url: '/rent-flex-desk-coworking-bratislava',
        cta: 'mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork Flex Desk' }, { name: 'Fix Desk', time: '24/7 🌃', description: ['Dedicated desk', 'Own Plant 🌿', '180cm long desk 📏'],
        price: '200', period: 'month', highlight: 'true',
        url: '/rent-fix-desk-coworking-bratislava',
        cta: 'mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork Fix Desk' }, { name: 'Meeting Room 🤝', time: 'Acoustically insulated 🎧', description: ['10 seats 💺', 'Whiteboard 🎨', 'Projector 📽 '], price: '10', period: 'hour',
        url: '/rent-meeting-room-coworking-bratislava',
        cta: 'mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork Meeting Room' }]
    };
  }
});

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "input[data-v-d1031faa]{background-color:#fff}.content ul[data-v-d1031faa]{list-style-type:square;margin-top:0}.card-content[data-v-d1031faa]{padding:1rem}.offer-price[data-v-d1031faa]{text-align:center;padding-top:1rem;font-size:1.2rem;font-weight:700}article[data-v-d1031faa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.tile article .title[data-v-d1031faa]{font-size:1rem;text-align:center}.tile article a.button.is-black[data-v-d1031faa]{border:1px solid #fff;-ms-flex-item-align:end;align-self:flex-end}.is-highlighted[data-v-d1031faa],.tile article a.button.is-black[data-v-d1031faa]:hover{background-image:-webkit-gradient(linear,left bottom,right top,from(#b60cf6),color-stop(#9316e5),color-stop(#711ad4),color-stop(#4c1ac1),to(#1e19ae));background-image:-webkit-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:-o-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:linear-gradient(to right top,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae)}.notification[data-v-d1031faa]{padding:1.2rem;border:1px solid hsla(0,0%,100%,.2)}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/Offer.vue"],"names":[],"mappings":"AACA,uBACE,qBAA0B,CAC3B,AACD,6BACE,uBAAwB,AACxB,YAAc,CACf,AACD,+BACE,YAAc,CACf,AACD,8BACE,kBAAmB,AACnB,iBAAkB,AAClB,iBAAkB,AAClB,eAAkB,CAEnB,AACD,yBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,sCACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,iDACE,sBAAwB,AACxB,wBAAyB,AACrB,mBAAqB,CAC1B,AAOD,wFACE,sJAA8J,AAC9J,8FAAoG,AACpG,yFAA+F,AAC/F,sFAA6F,CAC9F,AACD,+BACE,eAAgB,AAChB,mCAA2C,CAC5C","file":"Offer.vue","sourcesContent":["\ninput[data-v-d1031faa] {\n  background-color: #ffffff;\n}\n.content ul[data-v-d1031faa] {\n  list-style-type: square;\n  margin-top: 0;\n}\n.card-content[data-v-d1031faa] {\n  padding: 1rem;\n}\n.offer-price[data-v-d1031faa] {\n  text-align: center;\n  padding-top: 1rem;\n  font-size: 1.2rem;\n  font-weight: bold;\n  /* border-top: 1px solid black; */\n}\narticle[data-v-d1031faa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.tile article .title[data-v-d1031faa] {\n  font-size: 1rem;\n  text-align: center;\n}\n.tile article a.button.is-black[data-v-d1031faa] {\n  border: 1px solid white;\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n.tile article a.button.is-black[data-v-d1031faa]:hover {\n  background-image: -webkit-gradient(linear, left bottom, right top, from(#b60cf6), color-stop(#9316e5), color-stop(#711ad4), color-stop(#4c1ac1), to(#1e19ae));\n  background-image: -webkit-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: -o-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: linear-gradient(to right top, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n}\n.is-highlighted[data-v-d1031faa] {\n  background-image: -webkit-gradient(linear, left bottom, right top, from(#b60cf6), color-stop(#9316e5), color-stop(#711ad4), color-stop(#4c1ac1), to(#1e19ae));\n  background-image: -webkit-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: -o-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: linear-gradient(to right top, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n}\n.notification[data-v-d1031faa] {\n  padding: 1.2rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(156);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("2cd57e92", content, true, {});

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(160),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d1031faa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.plans.slice(_vm.rangeStart, _vm.rangeEnd)), function(plan) {
    return _c('div', {
      staticClass: "tile is-parent is-size-4"
    }, [_c('article', {
      staticClass: "tile is-child notification is-black",
      class: {
        'is-highlighted': plan.highlight
      }
    }, [_c('div', {
      staticClass: "content"
    }, [(plan.url) ? _c('p', {
      staticClass: "title is-size-3"
    }, [_c('router-link', {
      attrs: {
        "to": plan.url
      }
    }, [_vm._v("\n            " + _vm._s(plan.name))])], 1) : _c('p', {
      staticClass: "title is-size-3"
    }, [_vm._v(_vm._s(plan.name))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', [_vm._v(_vm._s(plan.time))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(plan.description[0]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(plan.description[1]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(plan.description[2]))])])]), _vm._v(" "), _c('div', {}, [_c('a', {
      staticClass: "button is-black is-block is-large",
      attrs: {
        "href": plan.cta
      }
    }, [_vm._v(_vm._s(plan.price) + "€ / " + _vm._s(plan.period))])])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Offer__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Offer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Offer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Offer: __WEBPACK_IMPORTED_MODULE_0__Offer___default.a
  },
  name: "Page404"
});

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "a[data-v-45424dd8]{color:hotpink}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/Page404.vue"],"names":[],"mappings":"AACA,mBACE,aAAe,CAChB","file":"Page404.vue","sourcesContent":["\na[data-v-45424dd8] {\n  color: hotpink;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(194);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("42b8cc55", content, true, {});

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Page404"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns is-10 content has-text-white"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-white"
  }, [_c('p', [_vm._v("Looks like you've just found end of our coworking webpage.")]), _vm._v(" "), _c('p', [_vm._v("You are "), _c('router-link', {
    attrs: {
      "to": "/contact-venue"
    }
  }, [_vm._v("welcome to come over for free day pass 😋")])], 1)]), _vm._v(" "), _c('p', [_vm._v("🎯 Space for focused work")]), _vm._v(" "), _c('p', [_vm._v("🙌\n            "), _c('router-link', {
    attrs: {
      "to": "rent-flex-desk-coworking-bratislava"
    }
  }, [_vm._v("\n            Space for collaborative work\n            ")])], 1), _vm._v(" "), _c('p', [_vm._v("🛋 Space for relaxation")]), _vm._v(" "), _c('p', [_vm._v("🍷 Community Social Events")]), _vm._v(" "), _c('p', [_vm._v("⚡️ Ultra-fast Internet")]), _vm._v(" "), _c('p', [_vm._v("💬 Hangout areas")]), _vm._v(" "), _c('p', [_vm._v("🔐 Private call room")]), _vm._v(" "), _c('p', [_vm._v("🤝\n            "), _c('router-link', {
    attrs: {
      "to": "meeting-room-cowork-bratislava"
    }
  }, [_vm._v("Meeting rooms\n            ")])], 1)])])]), _vm._v(" "), _c('Offer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-8"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/making_movie_cowork.jpg",
      "alt": "coworking bratislava making movie"
    }
  })])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.21babd61a1398f2174c0.js